import React from "react"
import { SelectContext } from "./Select"



// Select Value Component
interface SelectValueProps extends React.HTMLAttributes<HTMLSpanElement> {
    placeholder?: string
}

export const SelectValue = React.forwardRef<HTMLSpanElement, SelectValueProps>(
    ({ className = "", placeholder }, ref) => {
        const { value } = React.useContext(SelectContext)
        return (
            <span ref={ref} className={`block truncate ${className}`}>
                {value || placeholder}
            </span>
        )
    }
)
SelectValue.displayName = "SelectValue"